import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import AppHeader from "../../Layout/AppHeader/index.js";
import { withTranslation } from "react-i18next";
import * as configApi from '../../config/configApi.js';
import ListPatient from './ListPatient.js'


function Index(props) {

  useEffect(() => {
  }, []);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <div className="app-main__outer">
          <div className="app-main__inner">
            <ListPatient/>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  global: state.global,
});
export default connect(mapStateToProps)(
 withTranslation(["listpatient"]) (Index));
